import { Capacitor } from '@capacitor/core'

export const useIsIOS = () => {
  return Capacitor.getPlatform() === 'ios'
}

export const useIsAndroid = () => {
  return Capacitor.getPlatform() === 'android'
}

export const useIsNative = () => {
  return Capacitor.getPlatform() !== 'web'
}
